<template lang="pug">
v-app.services-page
  xo-toolbar
  .services-section.mx-auto(style="max-width: 1600px; width: 100%")
    .section-1
      .services-banner
        .vertical-border-blue
        .text-container
          p.subtitle We know what it's like to take the leap. So we are committed to ensuring that the financial investment you make in your business will be worth it.
        v-spacer
        .d-flex.avatar-container
          img.mr-1.center.img-service1(
            src="/images/new/services/Services1.jpg"
          )
          img.mr-1.left.img-service2(src="/images/new/services/Services2.jpg")

      .services-container
        .div.card-container
          .testimonial-card
            v-card.py-2(:elevation="6", style="margin-left: auto")
              v-card-text.d-flex.justify-items-end.flex-column
                v-btn.service-btn(style="min-width: 100%") OPERATIONS SUPPORT
                .services-list.text-black
                  .div.d-flex.flex-inline.align-center.px-3(
                    v-for="(service, index) in supports",
                    :key="index"
                  )
                    img.mr-2.mr-sm-1(
                      src="/images/new/logos/justasklogo.png",
                      width="30",
                      height="30"
                    )
                    p.mt-1.mb-1 {{ service }}
                .d-flex.flex-column.align-items-center.justify-center
                  p.mb-1(style="font-style: italic; color: black") Maximum of 100 hours per month.
                  v-btn.service-btn2(style="min-width: 100%") <span style="text-transform: lowercase; margin-right: 3px;">starts at </span> {{ currency }} {{ amountSupport }}

          .testimonial-card
            v-card.py-2(:elevation="6")
              v-card-text.d-flex.justify-end.flex-column
                v-btn.service-btn(style="min-width: 100%") OPERATIONS PLUS+

                .services-list-2.text-black
                  .d-flex.flex-inline.px-3(
                    v-for="(service, index) in plus",
                    :key="index",
                    style="padding-bottom: 0 !important"
                  )
                    img.mr-2.mr-sm-1(
                      src="/images/new/logos/justasklogo.png",
                      width="30",
                      height="30"
                    )
                    p.mt-1.mb-0(v-html="service")

                .btn-action2.d-flex.flex-column.align-items-center.justify-center
                  p.mb-1(style="font-style: italic; color: black") Maximum of 100 hours per month.
                  v-btn.service-btn2(style="min-width: 100%") <span style="text-transform: lowercase; margin-right: 3px;">starts at </span> {{ currency }} {{ amountPlus }}

          .d-flex.flex-column.testimonial-card-3
            p.subtitle-footer.font-weight-medium.text-black.my-0 SEE HOW WE CAN MULTIPLY
            p.subtitle-footer.font-weight-medium.text-black.my-0 YOUR PRODUCTIVITY
            p.subtitle-footer.font-weight-medium.text-black WHILE SAVING YOUR ENERGY.
            div
              a.cPrimary-btn.v-btn.w-100(
                href="https://calendly.com/justaskph/45min",
                target="_blank"
              ) LET'S HOP ON A CALL
              v-select.mt-5(
                dense,
                solo,
                validate-on-blur,
                label="Choose Currency",
                v-model="currency_id",
                item-text="name",
                item-value="id",
                :items="currency_list",
                @change="changeCurrency($event)"
              )
              label.mt-n5 Select Currency

      //- .services-banner-footer
      //-     .vertical-border-blue-footer-1
      //-     .second-section
      //-         div.d-flex.flex-column
      //-             p.subtitle-footer.font-weight-medium.text-black SEE HOW WE CAN MULTIPLY YOUR.
      //-             p.subtitle-footer.font-weight-medium.text-black PRODUCTIVITY WHILE SAVING YOUR ENERGY.
      //-         a.cPrimary-btn.v-btn(href="https://calendly.com/justaskph/45min" target="_blank") LET'S HOP ON A CALL

    .section-2.d-flex.flex-column(style="width: 100wh !important")
      .services-banner-2
        .vertical-border-orange
        .service-banner-content-2.d-flex.align-self-center(
          style="width: 100%; max-width: 1400px"
        )
          .title-2 Our Process

          .service-our-process.d-flex.flex-inline
            img.mt-n5(
              src="/images/new/logos/justasklogowhite.png",
              width="95",
              height="95"
            )
            div
              p.subtitle-2 We assure you that the whole process is guided by our
              p.subtitle-2 <strong>VALUES, PRINCIPLES, AND STANDARDS.</strong>

      //- .d-flex.justify-content-center.align-items-center(style="margin-top:40px; margin-bottom:44px")
      .service-2-content.d-flex.align-items-center
        v-card.service-2-card.font-weight-bold.mx-auto(:elevation="6")
          v-card-text.d-flex.justify-center.align-center.flex-column
            .service-btn.text-center(style="min-width: 100%") OUR TEAMS ARE READY TO GO
            .pt-4.text-black.font-weight-medium
              p.service-text Our packages come with management oversight so that you don't have to worry about handholding or training anyone up to speed.
              p.service-text We also dedicate a lot of time upfront in a stringent onboarding process to learn about your business so that we start right from the beginning. We'll be with you every step of the way.

        .mx-auto
          img.section-2-img.mr-4.mt-3(
            src="/images/new/services/Process chart.png"
          )

      //- .horizontal-border-orange

    .section-3.d-flex.flex-column(style="width: 100wh !important")
      .services-banner-3
        .vertical-border-blue
        .text-container-whyjustask
          p.text-whyjustask Why
          p.text-whyjustask JustAsk!
          .d-flex.flex-inline.align-items-center
            img.section-3-imgfooter(src="/images/new/logos/justasklogo.png")
            .label.section-3-label.font-weight-medium WE DON'T WASTE TIME, WE SAVE IT!

        v-spacer
        .d-flex.avatar-container
          img.mr-1.center.img-whyjustask1(
            src="/images/new/services/Why JustAsk1.jpg"
          )
          img.mr-1.left.img-whyjustask2(
            src="/images/new/services/Why JustAsk2.jpg"
          )

      .section-3-content.d-flex.align-items-center
        .section-values.div.d-flex.flex-column
          p.text-value-title.text-orange-3.font-weight-bold(
            style="margin: 0 0 0 30px"
          ).text-we-value WE VALUE
          .section-3-values.d-flex.flex-inline.align-items-start
            img.mr-sm-2(
              src="/images/new/logos/justasklogo.png",
              width="25",
              height="25",
              style="margin-right: 12px"
            )
            .d-flex.flex-column.mt-1
              label.text-value-title.font-weight-bold EYE FOR EXCELLENCE
              .d-flex.flex-inline.text-black
                v-icon.mr-sm-2.sm-bullet-1.bullet-1-label-1(
                  color="#020202",
                  size="8",
                  style="margin-right: 10px;"
                ) mdi-checkbox-blank-circle
                label.text-value-subtitle We meticulously attend to every detail to ensure the realization of your goals and commitments.
                //- label.text-value-subtitle we make sure that you follow through on your goals and commitments

          .section-3-values.d-flex.flex-inline.mt-3
            img.mr-sm-2(
              src="/images/new/logos/justasklogo.png",
              width="25",
              height="25",
              style="margin-right: 12px"
            )
            .d-flex.flex-column.mt-1
              label.text-value-title.font-weight-bold RELIABLE CONSISTENCY
              .text-value-subtitle.d-flex.flex-inline.text-black
                v-icon.mr-sm-2.sm-bullet-1(
                  color="#020202",
                  size="8",
                  style="margin-right: 10px"
                ) mdi-checkbox-blank-circle
                label You can depend on the continuity of our outcomes.
          .section-3-values.d-flex.flex-inline.mt-3
            img.mr-sm-2(
              src="/images/new/logos/justasklogo.png",
              width="25",
              height="25",
              style="margin-right: 12px"
            )
            .d-flex.flex-column.mt-1
              label.text-value-title.font-weight-bold EVERYDAY INTEGRITY
              .text-value-subtitle.d-flex.flex-inline.text-black
                v-icon.mr-sm-2.sm-bullet-1(
                  color="#020202",
                  size="8",
                  style="margin-right: 10px"
                ) mdi-checkbox-blank-circle
                label Our ethical principles ensure trustworthiness and accountability.
                //- label we take ownership of our outcomes

        .section-mission-vision.d-flex.flex-column.align-items-start
          label.text-mission-vision.text-orange-3.font-weight-bold OUR VISION
          label.text-black is to empower visionary leaders and decision-makers to focus on their core strategies and brilliant ideas.

          label.text-mission-vision.text-orange-3.font-weight-bold.mt-4 OUR MISSION
          label.text-black is to elevate your business by delivering skilled expertise that supports essential business functions.  Through our personal assistant services, the tasks that need to get done are seamlessly managed, ensuring everything runs smoothly and giving you the headspace to focus on what truly matters.

      //- .section-3-footer.d-flex.align-center
        div.d-flex.flex-inline.align-items-center(style="margin:0 auto")
                img(src="/images/new/logos/justasklogo.png", ).section-3-imgfooter.mr-4
                .label.section-3-label.font-weight-medium WE DON'T WASTE TIME, WE SAVE IT!




    .section-3.d-flex.flex-column(style="width: 100wh !important")
      .services-banner-3
        .vertical-border-blue
        .section-4-text-container
          p.text-faq1 FAQ
          p.text-faq2.mb-0 FREQUENTLY
          p.text-faq2.mb-0 ASKED
          p.text-faq2.mb-0 QUESTIONS
        v-spacer
        .d-flex.avatar-container-4
          img.mr-1.center.img-faq1(src="/images/new/services/FAQ1.png")
          img.mr-1.left.img-faq2(src="/images/new/services/FAQ2.png")

      .section-4-content.d-flex.flex-column.align-items-center
        .d-flex.flex-column.mt-1
          label.text-title.font-weight-bold What if I require a different type of assistance that is not on your list?
          .text-black
            label.text-subtitle We will be happy to discuss your requirements so we can create a custom support package for you.

        .d-flex.flex-column.mt-1
          label.text-title.font-weight-bold What if I don't need a whole team? I'm just looking for an assistant?
          .text-black
            label.text-subtitle This is exactly what differentiates JustAsk! from other service providers. Our value lies in freeing you of all the things that can stress you out as you juggle everything that's happening in our life.

        .d-flex.flex-column.mt-1
          label.text-title.font-weight-bold What if I already have systems in place?
          .text-black
            label.text-subtitle We're happy to learn and adapt to what you've been doing. Because of our expertise and experience, we may also recommend free and paid updates to increase oversight and improve efficiencies of your business.
</template>

<script>
export default {
    data() {
        return {
            supports: [
                "File management",
                "Order processing and fulfillment",
                "Billing (invoicing and collecting)",
                "Customer communications support",
                "Calendar management",
                "Database management",
            ],
            plus: [
                "All of <b>Operations Support</b> plus:",
                "Meeting support",
                "Basic finance functions",
                "Online events management",
            ],
            avatar: [
                "Logo apperPH",
                "Logo Area63",
                "Logo BGA",
                "LogoDigitalMinds",
                "Logo Homeopathy PH",
                "Logo mocean-DkBlue",
                "Logo PixOwl",
                "Logo Sprinkle FIC",
                "LogoTheSecretSauce",
                "LogoVIPTraveler",
                "Logo Wivity",
                "Logo YGG Pinas",
                "Logo YGG",
            ],
            currency_list: [],
            currency_id: 3,
            currency: "USD",
            amountSupport: "Loading..",
            amountPlus: "Loading..",
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        async load() {
            const { data } = await axios.get(
                "https://v6.exchangerate-api.com/v6/79329a46417f17d63206890d/latest/PHP"
            );
            // const data = [];
            let list = [];
            let indexdata = 0;
            Object.keys(data.conversion_rates).map((key, index) => {
                if (
                    key == "PHP" ||
                    key == "USD" ||
                    key == "EUR" ||
                    key === "AUD"
                ) {
                    list.push({
                        name: key,
                        id: indexdata,
                        value: data.conversion_rates[key],
                    });
                    indexdata++;
                }
            });

            this.currency_list = list;
            this.changeCurrency();
        },
        changeCurrency() {
            let e = this.currency_id;
            console.log(e);
            console.log(this.currency_list[e]);
            this.currency = this.currency_list[e].name;
            let v = this.currency_list[e].value;
            let amtSuppport = v * 40000;
            let amtPlus = v * 50000;

            this.amountSupport = this.AmountToMoney(amtSuppport);
            this.amountPlus = this.AmountToMoney(amtPlus);
        },
        AmountToMoney(x) {
            if (x != null) {
                x = this.MoneyToNum(x);
            }
            x = this.Money(x);
            return x == NaN ? "" : x;
        },
        MoneyToNum(x) {
            let num = 0;
            if (x == 0 || x == null) {
                num = "0.00";
            } else {
                num = Number(x.toString().replace(/,/g, ""));
            }
            return num;
        },
        Money(x) {
            var num = parseFloat(x).toFixed(2);
            var parts = num.split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        },
    },
};
</script>

<style lang="scss" scoped>
// .services-page {
//     font-family: GothamRounded;
// }
.testimonial-card {
    border-radius: 10px;
}
.text-orange {
    color: #f15c24;
}
.text-orange-3 {
    color: #f59b22;
    font-weight: 500;
}
.text-blue {
    color: #009cb1;
}

@media (max-width: 599px) {
    .text-we-value {
        margin: 0 0 0 37px !important;
    }
}

//large
@media (min-width: 1265px) {

    .bullet-1-label-1{
        height: 1px !important; align-items: top !important; padding-top: 13px !important;
    }

    .vertical-border-blue {
        border-left: 50px solid #009cb5;
        border-right: 20px solid #7dccad;
        height: 400px;
    }
    .services-page {
        .services-section {
            margin-top: 60px;

            .section-1 {
                .services-banner {
                    display: flex;
                    align-items: center;
                    background-color: #f2f2f2;
                    padding: 0 80px;

                    .avatar-container {
                        background-color: #7dccad;

                        img.img-service1 {
                            height: 400px;
                            max-width: 218px;
                            // max-width: 283px;
                            object-fit: cover;
                            object-position: 50%;
                        }
                        img.img-service2 {
                            height: 400px;
                            max-width: 471px;
                            // max-width: 532px;
                            object-fit: cover;
                            transform: scaleX(-1);
                        }
                        .center {
                            object-position: 20% 0;
                        }
                        .left {
                            object-position: 80% 0;
                        }
                        .mr-1 {
                            margin-right: 5px;
                        }
                    }
                    .text-container {
                        max-width: 553px;
                        .subtitle {
                            line-height: 30px;
                            font-size: 1.4rem;
                            font-style: italic;
                            font-weight: 500;
                            padding: 0 40px;
                            max-height: 352px;
                        }
                    }
                }

                .services-container {
                    position: relative;
                    margin: auto;
                    display: flex;
                    justify-content: center;
                    padding: 0 100px;
                    margin: 58px 0 96px 0;
                    // margin: 50px 100px 50px 0;
                    // .title {
                    //     font-size: 40px;
                    //     font-weight: 100;
                    //     line-height: 35px;
                    // }
                    .card-container {
                        // position: absolute;
                        // top: -100px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .testimonial-card {
                            margin-top: 30px;
                            position: relative;
                            max-width: 470px;
                            margin: 20px 30px;

                            .service-btn {
                                color: white;
                                font-weight: bold;
                                background: #f15c24;
                                border-radius: 10px;
                                max-width: max-content;
                                font-size: 1.1rem;
                                padding: 28px 45px;
                            }

                            .service-btn2 {
                                color: white;
                                font-weight: bold;
                                background: #f15c24;
                                border-radius: 10px;
                                max-width: max-content;
                                font-size: 1.1rem;
                                padding: 10px 45px;
                            }

                            .v-card__text {
                                padding: 10px 35px;

                                .services-list {
                                    padding: 10px 6px;
                                }
                                .services-list-2 {
                                    padding: 10px 6px 34px 6px;
                                }
                            }

                            // height: 100%;
                            .testimonial-details {
                                margin: 0 30px;
                                font-size: 1.1rem;
                                font-weight: 500;
                                img {
                                    height: 60px;
                                    border-radius: 10px;
                                }
                            }
                            .btn-action2 {
                                margin-top: 31px;
                            }
                        }
                        .testimonial-card-3 {
                            max-width: 321px;
                            margin: 20px 30px;
                            p {
                                font-weight: normal;
                                font-size: 1.15rem;
                            }
                        }
                        .cPrimary-btn {
                            color: white;
                            font-weight: bold !important;
                            background: #fa9221;
                            border-radius: 10px;
                            box-shadow: 4px 3px 0px 0px #1f9297;
                            max-width: max-content;
                            font-size: 1.2rem;
                            padding: 1px 20px;
                            height: 50px;
                            // margin-right: 80px;
                            // margin-right: 179px;
                        }
                        .v-select {
                            width: 297px;
                            height: 47px;
                        }
                    }
                }

                // .services-banner-footer {
                //     // margin-top: 273px;
                //     display: flex;
                //     align-items: center;
                //     background-color: #f2f2f2;
                //     padding: 0 80px;

                //     .second-section {
                //         // width: 945px;
                //         width: 1070px;
                //         display: flex;
                //         align-self: start;
                //         justify-content: space-between;
                //         margin-top: 70px;
                //         margin: auto;
                //         .subtitle-footer {
                //             line-height: 10px;
                //             font-size: 1.33rem;
                //             font-weight: normal;
                //         }
                //         .cPrimary-btn {
                //             color: white;
                //             font-weight: bold !important;
                //             background: #fa9221;
                //             border-radius: 10px;
                //             box-shadow: 4px 3px 0px 0px #1f9297;
                //             max-width: max-content;
                //             font-size: 1.2rem;
                //             padding: 1px 20px;
                //             height: 50px;
                //             // margin-right: 80px;
                //             margin-right: 179px;
                //         }
                //     }
                // }
            }

            .section-2 {
                .services-banner-2 {
                    display: flex;
                    align-items: center;
                    background-color: #f89e35;
                    padding: 0 80px;
                    max-height: 180px;
                    .vertical-border-orange {
                        border-left: 50px solid #ed1c24;
                        border-right: 20px solid #f15a24;
                        height: 180px;
                    }

                    .service-banner-content-2 {
                        .title-2 {
                            font-size: 4.32rem;
                            color: white;
                            line-height: 85px;
                            font-weight: lighter;
                            align-items: end;
                            margin: auto 96px 0 64px;
                        }
                        .service-our-process {
                            align-items: end;
                            .subtitle-2 {
                                max-width: 540px;
                                line-height: 19px;
                                font-size: 1.35rem !important;
                                padding: 0;
                            }
                        }
                    }
                }

                .services-logo-container {
                    margin: 0 auto;
                    max-width: 90%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 230px;
                    }
                }
                .mr-5 {
                    margin-right: 30px;
                }

                .service-2-content {
                    max-height: 704px;
                    padding: 65px 145px 106px 145px;
                    .service-2-card {
                        max-width: 418px;
                        padding: 10px 20px;

                        .service-btn {
                            color: white;
                            font-weight: bold;
                            background: #f15c24;
                            border-radius: 10px;
                            max-width: max-content;
                            font-size: 1.1rem;
                            padding: 16px 3px;
                        }

                        .service-btn2 {
                            color: white;
                            font-weight: bold;
                            background: #f15c24;
                            border-radius: 10px;
                            max-width: max-content;
                            font-size: 1.1rem;
                            padding: 10px 45px;
                        }

                        .service-text {
                            font-size: 1rem;
                            line-height: 25px;
                        }
                    }
                    .section-2-img {
                        margin-top: 20px;
                        height: 500px;
                        max-width: 621px;
                        // width: 668px;
                    }
                }
                .horizontal-border-orange {
                    height: 50px;
                    background-color: #f89e35;
                }
            }
            .section-3 {
                .services-banner-3 {
                    display: flex;
                    align-items: center;
                    background-color: #f2f2f2;
                    padding: 0 80px;

                    .text-container-whyjustask {
                        padding: 80px 0px;
                        .text-whyjustask {
                            font-weight: 100;
                            line-height: 65px;
                            margin-left: 50px;
                            font-size: 4.5rem;
                        }
                        .section-3-label {
                            font-size: 1rem;
                        }
                        .section-3-imgfooter {
                            width: 65px;
                            height: 65px;
                            margin-left: 42px;
                        }
                        div {
                            height: 20px;
                        }
                    }
                    .avatar-container {
                        background-color: #7dccad;
                        // .center {
                        //     object-position: center;
                        // }

                        img.img-whyjustask1 {
                            height: 400px;
                            width: 295px;
                            object-fit: cover;
                            object-position: 15%;
                        }
                        img.img-whyjustask2 {
                            height: 400px;
                            width: 532px;
                            object-fit: cover;
                            object-position: 15%;
                        }

                        .center {
                            object-position: 20% 0;
                        }
                        .left {
                            object-position: 80% 0;
                        }
                        .mr-1 {
                            margin-right: 5px;
                        }
                    }
                    .text-container {
                        max-width: 600px;
                        margin-left: 30px;
                        .subtitle {
                            line-height: 30px;
                            font-size: 1.45rem;
                            font-style: italic;
                            font-weight: 500;
                            padding: 0 20px;
                        }
                        .v-select {
                            width: 297px;
                            height: 47px;
                        }
                    }
                }

                .section-3-content {
                    // padding: 100px 0;
                    height: 414px;
                    justify-content: space-evenly;
                    padding: 0 65px 33px 50px;

                    margin: 0 60px;
                    max-width: 1600px;
                    .section-values {
                        .section-3-values {
                            .text-value-title {
                                font-size: 1rem;
                                letter-spacing: 1px;
                            }
                            .text-value-subtitle {
                                font-size: 1rem;
                                letter-spacing: 1px;
                                padding-right: 10px;
                            }
                        }
                    }
                    .text-we-value {
                        font-size: 1.75rem;
                    }

                    .section-mission-vision {
                        max-width: 540px;
                        .text-mission-vision {
                            font-size: 1.75rem;
                        }
                        .text-black {
                            font-size: 1rem;
                            letter-spacing: 1px;
                        }
                    }
                }

                // .section-3-footer {
                //     background-color: #f2f2f2;
                //     height: 120px;

                //     .section-3-imgfooter {
                //         width: 90px;
                //         height: 90px;
                //     }
                //     .section-3-label {
                //         font-size: 1.2rem;
                //     }
                // }
            }
        }

        //SECTION 4
        .section-4-text-container {
            .text-faq1 {
                font-size: 4.5rem;
                font-weight: 100;
                line-height: 30px;
                margin-left: 50px;
            }
            .text-faq2 {
                font-size: 1rem;
                font-weight: 100;
                line-height: 23px;
                margin-left: 57px;
                max-width: 183px;
            }
        }
        .avatar-container-4 {
            background-color: #7dccad;

            img.img-faq1 {
                height: 400px;
                width: 192px;
                object-position: 20%;
                object-fit: cover;
            }
            img.img-faq2 {
                height: 400px;
                width: 532px;
                object-position: 20%;
                object-fit: cover;
            }
        }
        .section-4-content {
            margin: 27px auto 51px auto;
            height: 364px;
            justify-content: space-evenly;
            padding: 0 55px;
            max-width: 725px;
            .text-title {
                font-size: 1rem;
                line-height: 20px;
            }
            .text-subtitle {
                font-size: 1rem;
                line-height: 20px;
            }
        }
    }

    .vertical-border-blue {
        border-left: 50px solid #009cb5;
        border-right: 20px solid #7dccad;
        max-height: 400px;
    }

    .vertical-border-blue-footer-1 {
        border-left: 50px solid #009cb5;
        border-right: 20px solid #7dccad;
        height: 170px;
    }
}
// medium
@media (min-width: 961px) and (max-width: 1264px) {

    .bullet-1-label-1{
        height: 1px !important; align-items: top !important; padding-top: 9px !important;
    }

    //SECTION 1
    .vertical-border-blue {
        border-left: 50px solid #009cb5;
        border-right: 20px solid #7dccad;
        height: 259px;
    }
    .services-page {
        .services-section {
            margin-top: 60px;
            max-height: 300px;

            .section-1 {
                .services-banner {
                    display: flex;
                    align-items: center;
                    background-color: #f2f2f2;
                    padding: 0 60px;

                    .avatar-container {
                        background-color: #7dccad;

                        img.img-service1 {
                            height: 259px;
                            width: 174px;
                            object-fit: cover;
                            object-position: 50%;
                        }
                        img.img-service2 {
                            height: 259px;
                            width: 336px;
                            object-fit: cover;
                            object-position: 67%;
                            transform: scaleX(-1);
                        }
                        .center {
                            object-position: 20% 0;
                        }
                        .left {
                            object-position: 80% 0;
                        }
                        .mr-1 {
                            margin-right: 5px;
                        }
                    }
                    .text-container {
                        max-width: 553px;

                        .subtitle {
                            line-height: 20px;
                            font-size: 0.9rem;
                            font-style: italic;
                            font-weight: 500;
                            padding: 0 25px;
                        }
                    }
                }
                .services-container {
                    position: relative;
                    margin: 10px 0 26px 0;
                    display: flex;
                    justify-content: space-evenly;
                    align-items: center;
                    .card-container {
                        // position: absolute;
                        top: -100px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .testimonial-card {
                            margin: 65px 20px;
                            max-width: 280px;
                            .v-card {
                                max-height: 268px;
                            }
                            .v-card__text {
                                padding: 10px 34px;

                                .services-list {
                                    padding: 10px 0;
                                }
                                .services-list-2 {
                                    padding: 10px 0 51px 0;
                                }
                            }
                            .service-btn {
                                color: white;
                                font-weight: 600px;
                                background: #f15c24;
                                border-radius: 6px;
                                max-width: max-content;
                                font-size: 0.65rem;
                                padding: 0 45px;
                                letter-spacing: 1px;
                            }
                            .service-btn2 {
                                color: white;
                                font-weight: 600px;
                                background: #f15c24;
                                border-radius: 6px;
                                // max-width: max-content;
                                font-size: 0.65rem;
                                padding: 14px 45px;
                                height: 13px;
                                letter-spacing: 1px;
                            }
                            .v-card__text {
                                padding: 10px 25px;

                                img {
                                    width: 20px;
                                    height: 20px;
                                }
                            }

                            p {
                                font-size: 0.62rem;
                                line-height: 10px;
                            }
                        }

                        .testimonial-card-3 {
                            max-width: 240px;
                            margin: 20px 30px;
                            p {
                                font-weight: normal;
                                font-size: 0.8rem;
                            }
                        }
                        .cPrimary-btn {
                            color: white;
                            font-weight: bold !important;
                            background: #fa9221;
                            border-radius: 10px;
                            box-shadow: 4px 3px 0px 0px #1f9297;
                            max-width: max-content;
                            font-size: 0.8rem;
                            padding: 1px 10px;
                            height: 30px;
                            // margin-right: 80px;
                            // margin-right: 179px;
                        }
                        .v-select {
                            width: 192px;
                            height: 44px;
                        }
                    }
                }
            }
        }

        // .services-banner-footer {
        //     display: flex;
        //     align-items: center;
        //     background-color: #f2f2f2;
        //     padding: 0 60px;
        //     // margin-top: 199px;

        //     .vertical-border-blue-footer-1 {
        //         border-left: 40px solid #009cb5;
        //         border-right: 15px solid #7dccad;
        //         height: 110px;
        //     }
        //     .second-section {
        //         max-width: 900px;
        //         display: flex;
        //         align-self: start;
        //         margin: auto;
        //         div {
        //             margin-top: 37px;
        //         }
        //         .subtitle-footer {
        //             line-height: 10px;
        //             font-size: 0.83rem;
        //             font-weight: normal;
        //             padding: 0 20px;
        //             // margin-top: 10px;
        //         }
        //         .cPrimary-btn {
        //             color: white;
        //             font-weight: bold !important;
        //             background: #fa9221;
        //             border-radius: 10px;
        //             box-shadow: 4px 3px 0px 0px #1f9297;
        //             font-size: 0.75rem;
        //             padding: 1px 20px;
        //             height: 34px;
        //             margin-right: 80px;
        //             margin-top: 38px;
        //         }
        //     }
        // }
    }

    //SECTION 2
    .section-2 {
        margin-top: 0;

        .services-banner-2 {
            display: flex;
            align-items: center;
            background-color: #f89e35;
            padding: 0 60px;
            height: 110px;
            .vertical-border-orange {
                border-left: 40px solid #ed1c24;
                border-right: 15px solid #f15a24;
                height: 110px;
            }
            .service-banner-content-2 {
                .title-2 {
                    font-size: 2.72rem;
                    color: white;
                    line-height: 75px;
                    align-items: end;
                    margin: auto 96px 0 64px;
                }
                img {
                    width: 70px;
                    height: 70px;
                }
                .service-our-process {
                    align-items: end;
                    .subtitle-2 {
                        max-width: 600px;
                        line-height: 12px;
                        font-size: 0.95rem !important;
                    }
                }
            }
        }

        .service-2-content {
            padding: 30px;
            margin: 15px 41px 54px 41px;
            .service-btn {
                color: white;
                font-weight: 600;
                background: #f15c24;
                border-radius: 5px;
                // max-width: max-content;
                font-size: 0.65rem;
                padding: 7px 18px;
            }
            .service-2-card {
                max-width: 296px;
                padding: 0 15px;

                .service-text {
                    line-height: 20px;
                    font-size: 0.75rem;
                }
            }
            .section-2-img {
                height: 339px;
                max-width: 433px;
            }
        }

        .horizontal-border-orange {
            height: 30px;
            background-color: #f89e35;
        }
    }

    //SECTION 3
    .section-3 {
        .services-banner-3 {
            display: flex;
            align-items: center;
            background-color: #f2f2f2;
            padding: 0 60px;

            .text-container-whyjustask {
                // font-size: 2.72rem;
                // font-weight: 100;
                // line-height: 65px;
                margin-left: 50px;

                .text-whyjustask {
                    font-size: 3.7rem;
                    line-height: 45px;
                    font-weight: 100;
                }
                .section-3-label {
                    font-size: 0.8rem;
                }
                .section-3-imgfooter {
                    width: 40px;
                    height: 40px;
                }
            }

            .avatar-container {
                background-color: #7dccad;

                img.img-whyjustask1 {
                    height: 259px;
                    width: 150px;
                    object-position: 20%;
                    object-fit: cover;
                }
                img.img-whyjustask2 {
                    height: 259px;
                    width: 320px;
                    object-position: 20%;
                    object-fit: cover;
                }
            }
        }
        .section-3-content {
            height: 318px;
            justify-content: space-evenly;
            padding: 0 55px;
            margin: 0 60px 20px 60px;
            max-width: 1600px;

            .section-values {
                .section-3-values {
                    .text-value-title {
                        font-size: 0.75rem;
                        letter-spacing: 1px;
                    }
                    .text-value-subtitle {
                        font-size: 0.75rem;
                        letter-spacing: 1px;
                        padding-right: 20px;
                    }
                }
            }
            .text-we-value {
                font-size: 1rem;
            }
            .section-mission-vision {
                max-width: 300px;
                margin-top: 5px;
                .text-mission-vision {
                    font-size: 1rem;
                }
                .text-black {
                    font-size: 0.75em;
                    letter-spacing: 1.7px;
                    padding-top: 5px;
                }
            }
        }

        .section-3-footer {
            padding: 10px auto;
            background-color: #f2f2f2;
            .section-3-imgfooter {
                width: 55px;
                height: 55px;
            }
            .section-3-label {
                font-size: 0.8rem;
            }
        }

        //SECTION 4
        .section-4-text-container {
            .text-faq1 {
                font-size: 3.7rem;
                font-weight: 100;
                line-height: 30px;
                margin-left: 50px;
            }
            .text-faq2 {
                font-size: 0.7rem;
                font-weight: 100;
                line-height: 15px;
                margin-left: 50px;
                max-width: 183px;
            }
        }
        .avatar-container-4 {
            background-color: #7dccad;

            img.img-faq1 {
                height: 259px;
                width: 192px;
                object-position: 20%;
                object-fit: cover;
            }
            img.img-faq2 {
                height: 259px;
                width: 320px;
                object-position: 20%;
                object-fit: cover;
            }
        }
        // .section-4-content {
        //     margin: auto;
        //     height: 318px;
        //     justify-content: space-evenly;
        //     padding: 0 55px;
        //     max-width: 725px;
        //     .text-title {
        //         font-size: 0.9rem;
        //         line-height: 18px;
        //     }
        //     .text-subtitle {
        //         font-size: 0.9rem;
        //         line-height: 18px;
        //     }
        // }

        //SECTION 4
        .section-4-text-container {
            .text-faq1 {
                font-size: 3.7rem;
                font-weight: 100;
                line-height: 30px;
                margin-left: 50px;
            }
            .text-faq2 {
                font-size: 0.7rem;
                font-weight: 100;
                line-height: 15px;
                margin-left: 50px;
                max-width: 183px;
            }
        }
        .avatar-container-4 {
            background-color: #7dccad;

            img.img-faq1 {
                height: 259px;
                width: 192px;
                object-position: 20%;
                object-fit: cover;
            }
            img.img-faq2 {
                height: 259px;
                width: 320px;
                object-position: 20%;
                object-fit: cover;
            }
        }
        .section-4-content {
            margin: 10px auto 31px auto;
            height: 318px;
            justify-content: space-evenly;
            padding: 0 55px;
            max-width: 725px;
            .text-title {
                font-size: 0.9rem;
                line-height: 18px;
            }
            .text-subtitle {
                font-size: 0.9rem;
                line-height: 18px;
            }
        }
    }
    .vertical-border-blue {
        border-left: 40px solid #009cb5;
        border-right: 15px solid #7dccad;
        max-height: 259px;
    }

    .vertical-border-blue-footer-1 {
        border-left: 40px solid #009cb5;
        border-right: 15px solid #7dccad;
        height: 110px;
    }
}

//small
@media (min-width: 599px) and (max-width: 961px) {
    .vertical-border-blue {
        border-left: 33px solid #009cb5;
        border-right: 10px solid #7dccad;
        height: 195px;
    }

    .services-page {
        .services-section {
            margin-top: 60px;
            max-height: 300px;

            .section-1 {
                .services-banner {
                    display: flex;
                    align-items: center;
                    background-color: #f2f2f2;
                    padding: 0 35px;

                    .avatar-container {
                        background-color: #7dccad;

                        img.img-service1 {
                            height: 195px;
                            width: 115px;
                            object-fit: cover;
                            object-position: 50%;
                        }
                        img.img-service2 {
                            height: 195px;
                            width: 273px;
                            object-fit: cover;
                            object-position: 67%;
                            transform: scaleX(-1);
                        }
                        .center {
                            object-position: 20% 0;
                        }
                        .left {
                            object-position: 80% 0;
                        }
                        .mr-1 {
                            margin-right: 5px;
                        }
                    }
                    .text-container {
                        max-width: 257px;

                        .subtitle {
                            line-height: 15px;
                            font-size: 0.7rem;
                            font-style: italic;
                            font-weight: 500;
                            padding: 0 12px;
                        }
                    }
                }
                .services-container {
                    position: relative;
                    margin: 5px auto 19px auto;

                    display: flex;
                    justify-content: space-evenly;
                    align-items: center;
                    .card-container {
                        // position: absolute;
                        top: -100px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .testimonial-card {
                            margin: 37px 20px;
                            max-width: 218px;
                            .v-card {
                                max-height: 268px;
                            }
                            .v-card__text {
                                padding: 0 25px;
                                .services-list {
                                    padding: 10px 0;
                                }
                                .services-list-2 {
                                    padding: 10px 0 60px 0;
                                }
                            }
                            .service-btn {
                                color: white;
                                font-weight: 600px;
                                background: #f15c24;
                                border-radius: 6px;
                                max-width: max-content;
                                font-size: 0.65rem;
                                padding: 0 45px;
                                letter-spacing: 1px;
                                height: 29px;
                            }
                            .service-btn2 {
                                color: white;
                                font-weight: 600px;
                                background: #f15c24;
                                border-radius: 6px;
                                // max-width: max-content;
                                font-size: 0.65rem;
                                padding: 12px 25px;
                                height: 13px;
                                letter-spacing: 1px;
                            }
                            .v-card__text {
                                padding: 0 15px;
                                img {
                                    width: 15px;
                                    height: 15px;
                                }
                            }

                            p {
                                font-size: 0.51rem;
                                line-height: 10px;
                            }
                        }
                        .testimonial-card-3 {
                            max-width: 157px;
                            margin: 20px 10px;
                            p {
                                font-weight: normal;
                                font-size: 0.65rem;
                            }
                        }
                        .cPrimary-btn {
                            color: white;
                            font-weight: bold !important;
                            background: #fa9221;
                            border-radius: 10px;
                            box-shadow: 4px 3px 0px 0px #1f9297;
                            max-width: max-content;
                            font-size: 0.7rem;
                            padding: 10px 20px;
                            height: 30px;
                            // margin-right: 80px;
                            // margin-right: 179px;
                        }
                        .v-select {
                            width: 192px;
                            height: 44px;
                        }
                    }
                }
            }
        }

        .services-banner-footer {
            display: flex;
            align-items: center;
            background-color: #f2f2f2;
            padding: 0 35px;
            // margin-top: 163px;

            .vertical-border-blue-footer-1 {
                border-left: 33px solid #009cb5;
                border-right: 10px solid #7dccad;
                height: 85px;
            }
            .second-section {
                max-width: 548px;
                display: flex;
                align-self: start;
                margin: auto;
                div {
                    margin-top: 37px;
                }
                .subtitle-footer {
                    line-height: 3px;
                    font-size: 0.65rem;
                    font-weight: normal;
                    padding: 0 10px;
                    // margin-top: 10px;
                }
                .cPrimary-btn {
                    color: white;
                    font-weight: bold !important;
                    background: #fa9221;
                    border-radius: 5px;
                    box-shadow: 4px 3px 0px 0px #1f9297;
                    font-size: 0.65rem;
                    padding: 1px 20px;
                    height: 25px;
                    margin-right: 60px;
                    margin-top: 38px;
                }
            }
        }
    }

    //SECTION 2
    .section-2 {
        margin-top: 0;

        .services-banner-2 {
            display: flex;
            align-items: center;
            background-color: #f89e35;
            padding: 0 35px;
            height: 95px;
            .vertical-border-orange {
                border-left: 33px solid #ed1c24;
                border-right: 10px solid #f15a24;
                height: 95px;
            }
            .service-banner-content-2 {
                .title-2 {
                    margin: auto 30px;
                    font-size: 2.3rem;
                    color: white;
                    line-height: 55px;
                    align-items: end;
                }
                img {
                    width: 53px;
                    height: 53px;
                    margin-right: 0;
                }
                .service-our-process {
                    align-items: end;
                    .subtitle-2 {
                        max-width: 600px;
                        line-height: 3px;
                        font-size: 0.73rem !important;
                    }
                }
            }
        }

        .service-2-content {
            padding: 17px;
            margin: 5px 41px 39px 41px;

            .service-btn {
                color: white;
                font-weight: 600;
                background: #f15c24;
                border-radius: 5px;
                // max-width: max-content;
                font-size: 0.55rem;
                padding: 6px 0;
            }
            .service-2-card {
                max-width: 223px;
                padding: 0 2px;

                .service-text {
                    line-height: 14px;
                    font-size: 0.54rem;
                    margin-bottom: 8px;
                }
            }
            .section-2-img {
                height: 262px;
                max-width: 347px;
            }
        }

        .horizontal-border-orange {
            height: 30px;
            background-color: #f89e35;
        }
    }

    //SECTION 3
    .section-3 {
        .services-banner-3 {
            display: flex;
            align-items: center;
            background-color: #f2f2f2;
            padding: 0 35px;

            .text-container-whyjustask {
                // font-size: 2.5rem;
                // line-height: 30px;
                margin-left: 20px;

                .text-whyjustask {
                    font-size: 2.5rem;
                    line-height: 30px;
                    font-weight: 100;
                }
                .section-3-label {
                    font-size: 0.65rem;
                }
                .section-3-imgfooter {
                    width: 35px;
                    height: 35px;
                    margin-left: 4px;
                }
            }
            .avatar-container {
                background-color: #7dccad;

                img.img-whyjustask1 {
                    height: 195px;
                    width: 120px;
                    object-position: 20%;
                    object-fit: cover;
                }
                img.img-whyjustask2 {
                    height: 195px;
                    width: 255px;
                    object-position: 20%;
                    object-fit: cover;
                }
            }
        }
        .section-3-content {
            height: 318px;
            justify-content: space-evenly;
            padding: 0 39px;
            margin: 5px 30px 12px 30px;
            max-width: 665px;
            .section-values {
                padding: 0 20px;
                .text-value {
                    font-size: 0.85rem;
                }
                .section-3-values {
                    v-icon {
                        size: 5;
                    }

                    .text-value-title {
                        font-size: 0.85rem;
                    }
                    .text-value-subtitle {
                        font-size: 0.8rem;
                        line-height: 15px;
                    }
                }
            }
            .text-we-value {
                font-size: 0.85rem;
            }
            .section-mission-vision {
                max-width: 280px;
                margin-top: -49px;
                .text-mission-vision {
                    font-size: 0.85rem;
                }
                .text-black {
                    font-size: 0.8em;
                    letter-spacing: 1px;
                }
            }
        }

        .section-3-footer {
            padding: 10px auto;
            background-color: #f2f2f2;
            align-items: center;
            .section-3-imgfooter {
                width: 50px;
                height: 50px;
            }
            .section-3-label {
                font-size: 0.7rem;
            }
        }
        //SECTION 4
        .section-4-text-container {
            .text-faq1 {
                font-size: 2.5rem;
                font-weight: 100;
                line-height: 30px;
                margin-left: 50px;
            }
            .text-faq2 {
                font-size: 0.7rem;
                font-weight: 100;
                line-height: 15px;
                margin-left: 50px;
                max-width: 183px;
            }
        }
        .avatar-container-4 {
            background-color: #7dccad;

            img.img-faq1 {
                height: 195px;
                width: 120px;
                object-position: 20%;
                object-fit: cover;
            }
            img.img-faq2 {
                height: 195px;
                width: 255px;
                object-position: 20%;
                object-fit: cover;
            }
        }
        .section-4-content {
            margin: 12px auto 44px auto;
            height: 318px;
            justify-content: space-evenly;
            padding: 0 55px;
            max-width: 580px;
            .text-title {
                font-size: 0.85rem;
                line-height: 18px;
            }
            .text-subtitle {
                font-size: 0.8rem;
                line-height: 18px;
            }
        }
    }
    .vertical-border-blue {
        border-left: 33px solid #009cb5;
        border-right: 10px solid #7dccad;
        max-height: 195px;
    }

    .vertical-border-blue-footer-1 {
        border-left: 33px solid #009cb5;
        border-right: 10px solid #7dccad;
        height: 110px;
    }
}
//xs
@media (min-width: 320px) and(max-width: 599px) {
    .services-page {
        .services-section {
            .section-1 {
                max-height: 1700px;
                .services-banner {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    background-color: #f2f2f2;
                    padding: 0px;

                    .avatar-container {
                        // background-color: #7dccad;
                        padding: 0 5px;
                        display: flex;
                        flex-direction: column;
                        img.img-service1 {
                            height: 284px;
                            width: 364px;
                            object-fit: cover;
                            margin-bottom: 5px;
                        }
                        img.img-service2 {
                            height: 284px;
                            width: 364px;
                            object-fit: cover;
                        }
                        .center {
                            object-position: 20% 0;
                        }
                        .left {
                            object-position: 80% 0;
                        }
                        .mr-1 {
                            margin-right: 5px;
                        }
                    }
                    .text-container {
                        max-width: 600px;
                        height: 200px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: auto;
                        padding: 30px 15px;
                        .subtitle {
                            line-height: 25px;
                            font-size: 1.1rem;
                            font-style: italic;
                            font-weight: 500;
                            margin: 30px auto;
                        }
                    }
                }

                .services-container {
                    .card-container {
                        position: block;
                        top: 0;

                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        margin: auto;

                        .testimonial-card {
                            margin: 10px auto;
                            max-height: 500px;
                            max-width: 324px;

                            .v-card {
                                max-height: 295px;
                            }
                            .v-card__text {
                                padding: 8px 25px;
                                img {
                                    width: 15px;
                                    height: 15px;
                                }
                                p {
                                    font-size: 0.75rem;
                                    line-height: 12px;
                                }
                                .services-list {
                                    padding: 10px 0;
                                }
                                .services-list-2 {
                                    padding-top: 10px;
                                }
                            }
                            .service-btn {
                                color: white;
                                font-weight: bold;
                                background: #f15c24;
                                border-radius: 10px;
                                max-width: max-content;
                                font-size: 1rem;
                                padding: 21px 68px;
                            }
                            .service-btn2 {
                                color: white;
                                font-weight: bold;
                                background: #f15c24;
                                border-radius: 10px;
                                max-width: max-content;
                                font-size: 1rem;
                                padding: 16px 30px;
                                margin-top: 10px;
                            }
                            .btn-action2 {
                                margin-top: 58px;
                            }
                        }

                        .testimonial-card-3 {
                            max-width: 330px;
                            margin: 20px 10px 40px 10px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            padding: 30px 0;
                            p {
                                text-align: center;
                                font-weight: normal;
                                font-size: 0.8rem;
                            }
                        }
                        .cPrimary-btn {
                            color: white;
                            font-weight: bold !important;
                            background: #fa9221;
                            border-radius: 5px;
                            box-shadow: 4px 3px 0px 0px #1f9297;
                            font-size: 1rem;
                            padding: 1px 15px;
                            height: 45px;
                            margin: auto;
                        }
                        .v-select {
                            width: 241px;
                            height: 44px;
                        }
                    }
                }

                .services-banner-footer {
                    display: flex;
                    align-items: center;
                    background-color: #f2f2f2;
                    padding: 0;
                    margin-top: 20px;
                    flex-direction: column;

                    .vertical-border-blue-footer-1 {
                        background-color: #009cb5;
                        height: 34px;
                        width: 100%;
                    }
                    .second-section {
                        max-width: 900px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        margin-top: 30px;
                        margin: auto;
                        padding: 30px 0;
                        .subtitle-footer {
                            line-height: 15px;
                            font-size: 0.9rem;
                            font-weight: normal;
                            padding: 0 20px;
                            text-align: center;
                        }
                        .cPrimary-btn {
                            color: white;
                            font-weight: bold !important;
                            background: #fa9221;
                            border-radius: 5px;
                            box-shadow: 4px 3px 0px 0px #1f9297;
                            font-size: 1rem;
                            padding: 1px 15px;
                            height: 45px;
                            margin: auto;
                        }
                    }
                }
            }

            //SECTION 2
            .section-2 {
                max-height: 810px;
                .services-banner-2 {
                    display: flex;
                    flex-direction: column;
                    background-color: #f89e35;
                    padding: 0;
                    height: 241px;

                    .service-banner-content-2 {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        margin: auto;
                        .title-2 {
                            font-size: 3.5rem;
                            color: white;
                            line-height: 65px;
                            padding: 0;
                            text-align: center;
                            margin: auto;
                        }
                        img {
                            width: 53px;
                            height: 53px;
                            margin-right: 0;
                        }
                        .service-our-process {
                            align-items: end;
                            .subtitle-2 {
                                max-width: 600px;
                                line-height: 3px;
                                font-size: 0.73rem !important;
                            }
                        }
                    }
                }
                .service-our-process {
                    padding: 30px 0;
                    // display: flex;
                    // flex-direction: column;
                }

                .vertical-border-orange {
                    background-color: #ed1c24;
                    height: 30px;
                    width: 100%;
                }
                .service-2-content {
                    display: flex;
                    flex-direction: column;
                    padding: 55px 0;
                    .service-btn {
                        color: white;
                        font-weight: 600;
                        background: #f15c24;
                        border-radius: 5px;
                        // max-width: max-content;
                        font-size: 0.55rem;
                        padding: 6px 0;
                    }
                    .service-2-card {
                        padding: 0 2px;
                        max-width: 324px;
                        .service-text {
                            line-height: 14px;
                            font-size: 0.75rem;
                            margin-bottom: 8px;
                        }
                    }
                    .section-2-img {
                        height: 262px;
                        max-width: 347px;
                    }
                }
                .horizontal-border-orange {
                    height: 30px;
                    background-color: #f89e35;
                }
            }

            //SECTION 3
            .section-3 {


                // .section-3-values {
                //   .sm-bullet-1 {
                //     align-items: top !important;
                //     padding-top: 9px !important;
                //   }
                // }
                .services-banner-3 {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    background-color: #f2f2f2;
                    padding: 0px;

                    // .text-container-whyjustask {
                    //     font-size: 1.1rem;
                    //     font-weight: 100;
                    //     line-height: 65px;
                    //     margin-left: 50px;
                    //     padding: 50px 0px;
                    // }
                    .text-container-whyjustask {
                        // font-size: 2.5rem;
                        // line-height: 30px;
                        padding: 50px 0px;
                        text-align: center;
                        .text-whyjustask {
                            font-size: 3rem;
                            line-height: 40px;
                            font-weight: 100;
                        }
                        .section-3-label {
                            font-size: 0.8rem;
                        }
                        .section-3-imgfooter {
                            width: 60px;
                            height: 60px;
                        }
                        div {
                            height: 20px;
                        }
                    }
                    .text-whyjustask {
                        font-size: 3rem;
                        line-height: 28px;
                    }

                    .avatar-container {
                        padding: 0 5px;
                        display: flex;
                        flex-direction: column;

                        img.img-whyjustask1 {
                            height: 284px;
                            width: 364px;
                            object-fit: cover;
                            margin-bottom: 5px;
                        }
                        img.img-whyjustask2 {
                            height: 284px;
                            width: 364px;
                            object-fit: cover;
                            object-position: 20%;
                        }

                        .center {
                            object-position: 20% 0;
                        }
                        .left {
                            object-position: 80% 0;
                        }
                    }
                }

                .section-3-content {
                    padding: 50px 30px;
                    display: flex;
                    flex-direction: column;

                    .section-mission-vision {
                        margin-top: 20px;
                        max-width: 300px;
                        padding: 0 10px;
                    }
                }
                .section-3-footer {
                    padding: 10px auto;
                    background-color: #f2f2f2;
                    .section-3-imgfooter {
                        width: 55px;
                        height: 55px;
                    }
                    .section-3-label {
                        font-size: 0.8rem;
                    }
                }
            }
        }
        //SECTION 4
        .section-4-text-container {
            padding: 50px 0;
            text-align: center;
            max-width: 300px;
            .text-faq1 {
                font-size: 3rem;
                font-weight: 100;
                line-height: 10px;
                margin: auto;
                padding: 50px 0;
            }
            .text-faq2 {
                font-size: 1.1rem;
                font-weight: 100;
                line-height: 20px;

                max-width: 183px;
            }
        }
        .avatar-container-4 {
            // background-color: #7dccad;
            flex-direction: column;
            align-items: center;
            padding: 0px;
            img.img-faq1 {
                height: 240px;
                width: 364px;
                object-position: 20%;
                object-fit: cover;
                margin-bottom: 5px;
            }
            img.img-faq2 {
                height: 240px;
                width: 364px;
                object-position: 20%;
                object-fit: cover;
            }
        }
        .section-4-content {
            margin: auto;
            height: 686px;
            justify-content: space-evenly;
            padding: 0 55px;
            max-width: 580px;
            .text-title {
                font-size: 1.1rem;
                line-height: 20px;
            }
            .text-subtitle {
                font-size: 1.1rem;
                line-height: 20px;
                margin: 10px auto;
            }
        }
    }

    .vertical-border-blue {
        background-color: #009cb5;
        height: 30px;
        width: 100%;
    }
}
</style>
